import {
	createDefaultKpiAPI,
	listDefaultOkrAPI,
	updateDefaultKpiAPI,
	searchKpiUserAPI,
	deleteKpi,
	myKpiDrAPI,
	kpiProgressAPI,
	exportMyKpiReportAPI,
	updateKpiDescriptionAPI,
	getKpiPendingApprovalListAPI,
	approveKpiAPI,
	getKpiProgressStatusAndPerformanceAPI,
} from '../services/MyKpiService';
import { getCycleDetailsApi } from '../services/CommonService';
import * as actionTypes from './actionTypes';
import { showLoader } from './common';

export const createDefaultKpi = (payload) => {
	return () => {
		return createDefaultKpiAPI(payload);
	};
};

export const editDefaultKpi = (payload) => {
	return () => {
		return createDefaultKpiAPI(payload);
	};
};

export const updateKpiKey = (payload) => {
	return () => {
		return updateDefaultKpiAPI(payload);
	};
};
export const getAdminDefaultKpiList = (data) => {
	return () => {
		return listDefaultOkrAPI(data);
	};
};
export const searchDirectReporteeSearch = (payload) => {
	return () => {
		return searchKpiUserAPI(payload);
	};
};
export const deleteUserKpi = (payload) => {
	return () => {
		return deleteKpi(payload);
	};
};
export const getKpiDrApiDetails = (data) => {
	return () => {
		return myKpiDrAPI(data);
	};
};

export const getKpiProgressStatusAndPerformance = (data) => {
	return () => {
		return getKpiProgressStatusAndPerformanceAPI(data);
	};
};

export const setKpiListReload = (payload) => ({
	type: actionTypes.SET_RELOAD_KPI_LIST,
	payload,
});

export const setKpiFilters = (payload) => ({
	type: actionTypes.SET_KPI_FILTER_CONDITION,
	payload,
});
export const resetKpiFilters = () => ({
	type: actionTypes.RESET_KPI_FILTER_CONDITION,
});
export const setShowKpiCreateOpen = (payload) => ({
	type: actionTypes.SET_SHOW_KPI_CREATE_OPEN,
	payload,
});

export const setShowKpiType = (payload) => ({
	type: actionTypes.SET_KPI_TYPE,
	payload,
});
export const setCycleDetailsForDefaultKpi = (payload) => ({
	type: actionTypes.SET_CYCLE_DETAILS_DEFAULT_KPI,
	payload,
});
export const failCycleDetailsForDefaultKpi = (payload) => ({
	type: actionTypes.FAIL_CYCLE_DETAILS_DEFAULT_KPI,
	payload,
});
export const pendingCycleDetailsForDefaultKpi = (payload) => ({
	type: actionTypes.PENDING_CYCLE_DETAILS_DEFAULT_KPI,
	payload,
});
export const getDefaultKpiCycleDetails = (data) => {
	return (dispatch) => {
		return getCycleDetailsApi(data)
			.then((response) => {
				if (response.status === 200) {
					const { entity } = response?.data || {};
					dispatch(setCycleDetailsForDefaultKpi(entity || null));
				} else {
					dispatch(failCycleDetailsForDefaultKpi(null));
				}
			})
			.catch((error) => {
				dispatch(pendingCycleDetailsForDefaultKpi(null));
			});
	};
};

// Dashboard Progress actions

const fetchDaboardProgressPending = () => ({
	type: actionTypes.KPI_PROGRESS_PENDING,
});
const fetchDaboardProgressCompleted = (payload) => ({
	type: actionTypes.KPI_PROGRESS_SUCCESS,
	payload,
});
const fetchDaboardProgressFailed = (error) => ({
	type: actionTypes.KPI_PROGRESS_FAILED,
	error,
});
export const highlightKpi = (currentTab) => {
	return {
		type: actionTypes.HIGHTLIGHT_KPI,
		currentTab,
	};
};

export const getKpiProgress = (data, showProgress = false) => {
	return (dispatch) => {
		showProgress && dispatch(showLoader(true));
		dispatch(fetchDaboardProgressPending());
		return kpiProgressAPI(data)
			.then((response) => {
				if (response.status === 200) {
					dispatch(fetchDaboardProgressCompleted(response.data));
				} else {
					dispatch(fetchDaboardProgressFailed('error'));
				}

				showProgress && dispatch(showLoader(false));
			})
			.catch((error) => {
				dispatch(fetchDaboardProgressFailed(error));
				showProgress && dispatch(showLoader(false));
			});
	};
};
export const exportMyKpiReport = (data) => {
	return () => {
		return exportMyKpiReportAPI(data);
	};
};

export const updateKpiDescription = (requestParam, data) => {
	return () => {
		return updateKpiDescriptionAPI(requestParam, data);
	};
};

export const getKpiPendingApprovalList = (data) => {
	return () => {
		return getKpiPendingApprovalListAPI(data);
	};
};

export const approveGoalKpi = (data) => {
	return () => {
		return approveKpiAPI(data);
	};
};
